import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_verifone_commander_event.js";
//#region src/bite_log_verifone_commander_event_helper.ts
var bite_log_verifone_commander_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 1: return "state-changed";
		case 2: return "token-initialized";
		case 3: return "token-initialize-failed";
		case 4: return "refresh-session-success";
		case 5: return "refresh-session-failed";
		case 6: return "begin-session-success";
		case 7: return "begin-session-failed";
		case 8: return "upload-token-success";
		case 9: return "upload-token-failed";
		case 10: return "connect-web-socket-success";
		case 11: return "connect-web-socket-failed";
		case 12: return "open-cashier-success";
		case 13: return "open-cashier-failed";
		case 14: return "fetch-menu-success";
		case 15: return "fetch-menu-failed";
		case 16: return "upload-menu-success";
		case 17: return "upload-menu-failed";
		case 18: return "post-transaction-success";
		case 19: return "post-transaction-failed";
		case 20: return "session-expired";
		case 21: return "session-recovery-failed";
		case 22: return "check-bite-menu-success";
		case 23: return "check-bite-menu-failed";
		case 24: return "native-ping-failed";
		case 25: return "native-ping-success";
		case 26: return "recover-from-disconnection-failed";
		case 27: return "close-cashier-success";
		case 28: return "close-cashier-failed";
		case 29: return "end-session-success";
		case 30: return "end-session-failed";
		case 31: return "post-transaction-business-failure";
		case 32: return "begin-session-business-failure";
		case 33: return "open-cashier-business-failure";
		case 34: return "close-cashier-business-failure";
		case 35: return "end-session-business-failure";
		case 36: return "fetch-menu-business-failure";
		case 37: return "refresh-session-business-failure";
		case 38: return "suspend-transaction-success";
		case 39: return "suspend-transaction-failed";
		case 40: return "suspend-transaction-business-failure";
		case 41: return "order-status-upload-success";
		case 42: return "order-status-upload-failed";
		case 43: return "order-status-ack-sent";
		case 44: return "order-status-ack-failed";
	}
}
//#endregion
export { bite_log_verifone_commander_event_helper_exports, name };

//# sourceMappingURL=bite_log_verifone_commander_event_helper.js.map